import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { BadgeCheck } from "lucide-react"

const getInitials = (value) => {
  if (!value) return "U"
  const trimmed = value.includes("@") ? value.split("@")[0] : value
  const parts = trimmed.replace(/[^a-zA-Z0-9 ]/g, " ").trim().split(/\s+/)
  if (parts.length === 0) return "U"
  return parts.slice(0, 2).map((part) => part[0]).join("").toUpperCase()
}

const TwitterProfileInfo = ({ displayName, handleLabel, avatarUrl, verified }) => {
  const initials = getInitials(displayName || handleLabel)

  if (!displayName && !handleLabel) return null

  return (
    <div className="flex items-center gap-3">
      <Avatar>
        {avatarUrl ? (
          <AvatarImage src={avatarUrl} alt={displayName} />
        ) : (
          <AvatarFallback className="text-xs font-semibold">
            {initials}
          </AvatarFallback>
        )}
      </Avatar>
      <div>
        <div className="flex items-center gap-1">
          <span className="text-sm font-semibold">{displayName}</span>
          {verified && <BadgeCheck className="size-6 fill-blue-500 text-black" />}
          <span className="text-sm text-muted-foreground">@{handleLabel}</span>
        </div>
      </div>
    </div>
  )
}

export default TwitterProfileInfo
